/**
 * @file getDefaultElementScroll
 * @author yuzong(yuzong@tencent.com)
 */
export function getDefaultElementScroll() {
  return {
    horizontal: 0,
    vertical: 0
  };
}